import { HttpClient } from "./HttpClient";
import * as endPoints from "../constants/endPoints"

export class FiltroService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getFiltroItems(bodyData) {
        const { data } = await this.http.postBody(endPoints.GET_FILTROS, bodyData)
        return data
    }
}

export class PlanesService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getCPlanesFamilia(bodyData) {
        const { data } = await this.http.postBody(endPoints.GET_CPLANES_FAMILIA, bodyData)
        return data
    }

    async getCPlanesServicio(bodyData) {
        const { data } = await this.http.postBody(endPoints.GET_CPLANES_SERVICIO, bodyData)
        return data
    }

    async getCPlanesCategoria(bodyData) {
        const { data } = await this.http.postBody(endPoints.GET_CPLANES_CATEGORIA, bodyData)
        return data
    }

}

export class CategoriesService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getCategoriesItems() {
        const { data } = await this.http.post(endPoints.GET_CATEGORIES)
        return data
    }
}

export class ChannelsService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getChannelsItems() {
        const { data } = await this.http.post(endPoints.GET_CHANNELS)
        return data
    }
}